import React, { useEffect } from "react";
import {
	MDBRow,
	MDBCol,
	MDBIcon,
	MDBContainer,
} from "mdbreact";

import SEO from "../components/SEO/Seo";
import Layout from "../Layouts/MasterLayout/MasterLayout";

import "../components/Css/contato.css";

export default function ContatoPage() {
	useEffect(() => {
		if (
			typeof window !== "undefined" &&
			window.document &&
			document.getElementById("rd-form-kub9g7u9") === null
		) {
			const script = document.createElement("script");

			script.src =
				"https://d335luupugsy2.cloudfront.net/js/rdstation-forms/stable/rdstation-forms.min.js";
			script.async = true;

			script.onload = () => {
				new RDStationForms(
					"graduacao-registro-de-interesse-f5696547c4e90aac7f05",
					"UA-32345233-1"
				).createForm();
			};

			document.body.appendChild(script);
		}
	}, []);

	return (
		<Layout color="#ffffff">
			<SEO
				title="Fale com a Feevale"
				description="Dúvidas sobre o vestibular ou os cursos? Fale com o time da Universidade Feevale!"
			/>

			<section className="contatoPage">
				<MDBContainer>
					<div className="contatoPage-header">
						<span className="contatoPage-eyebrow">ATENDIMENTO FEEVALE</span>

						<h1>Fale com a gente</h1>

						<p>
							Tem dúvidas sobre o vestibular, cursos ou formas de ingresso?
							Entre em contato com a Feevale.
						</p>
					</div>

					<MDBRow className="contatoPage-contatosRow">
						<MDBCol md="6" className="mb-3 mb-md-0">
							<a
								className="contatoPage-card"
								href="https://wa.me/555135868800"
								target="_blank"
								rel="noopener noreferrer"
							>
								<div className="contatoPage-cardIcone">
									<MDBIcon fab icon="whatsapp" />
								</div>

								<div className="contatoPage-cardConteudo">
									<span>WhatsApp</span>
									<strong>Chamar no WhatsApp</strong>
									<small>(51) 3586.8800</small>
								</div>

								<span className="contatoPage-cardSeta">→</span>
							</a>
						</MDBCol>

						<MDBCol md="6">
							<a
								className="contatoPage-card"
								href="tel:555135868800"
							>
								<div className="contatoPage-cardIcone">
									<MDBIcon icon="phone-alt" />
								</div>

								<div className="contatoPage-cardConteudo">
									<span>Telefone</span>
									<strong>(51) 3586.8800</strong>
									<small>Fale diretamente com a Feevale</small>
								</div>

								<span className="contatoPage-cardSeta">→</span>
							</a>
						</MDBCol>
					</MDBRow>

					<div className="contatoPage-mapaBloco">
						<div className="contatoPage-mapaCabecalho">
							<div>
								<span className="contatoPage-eyebrow">LOCALIZAÇÃO</span>
								<h2>Universidade Feevale</h2>
							</div>

							<p>
								Encontre a Universidade Feevale e veja a localização no mapa.
							</p>
						</div>

						<div className="contatoPage-mapa">
							<iframe
								src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d6933.3819795897625!2d-51.12111592203397!3d-29.670740055946062!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x951943931e5bed2f%3A0xc0d78c5c5ba599b5!2sUniversidade%20Feevale!5e0!3m2!1spt-BR!2sbr!4v1633267270111!5m2!1spt-BR!2sbr"
								title="Universidade Feevale"
								width="100%"
								height="100%"
								style={{ border: 0 }}
								frameBorder="0"
								loading="lazy"
							/>
						</div>
					</div>
				</MDBContainer>
			</section>
		</Layout>
	);
}
